import {UserProfileInterface} from '../reducers/users';
import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../store';
import {SpinnerIcon} from './icons';

export function UserLoader(props: {children: (p0: UserProfileInterface) => React.ReactNode}) {
    const user = useSelector((state: RootState) => state.userProfile);
    if (user.isLoading) {
        return (
            <div className={'flex flex-col items-center justify-center'}>
                <SpinnerIcon />
                <span className={'sr-only'}>Loading...</span>
            </div>
        );
    }
    if (user.error != null) {
        return (
            <div className={'flex flex-col items-center justify-center'}>
                <span className={'text-xl font-semibold text-red-600'}>Error</span>
                <span className={'text-sm font-semibold text-red-600'}>{user.error.message}</span>
            </div>
        );
    }
    return <>{props.children(user)}</>;
}
